"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var operators_1 = require("rxjs/operators"),
    cookie_1 = require("../classes/cookie"),
    uuid_1 = require("../classes/uuid"),
    Detection_1 = require("../implementation/Detection"),
    Interaction_1 = require("../implementation/Interaction"),
    Connectivity_1 = require("../implementation/Connectivity"),
    Progress_1 = require("../implementation/Progress"),
    Usability_1 = require("../implementation/Usability"),
    Initialisation_1 = require("../implementation/Initialisation"),
    Tutorial_1 = require("../implementation/Tutorial"),
    DataManager_1 = require("../classes/DataManager"),
    Strings_1 = require("../strings/Strings"),
    version_1 = require("../version"),
    PrismaSDK = function () {
  function t(t, i) {
    void 0 === i && (i = "https://api.prismade.net/prismaid"), this.uuid = "UNSET", this.appType = "web", this.coordinatesUnit = "points", this.screenResolutionScaleFactor = 1, this.connectivity = null, this.detection = null, this.interaction = null, this.progress = null, this.usability = null, this.initialisation = null, this.tutorial = null, this.strings = new Strings_1.Strings(), this.dataManager = null, this.serverURL = i, this.APIKey = t;
    var e = uuid_1.UUID.randomUUID();
    this.uuid = cookie_1.Cookie.getCookie("uuid", e), cookie_1.Cookie.setCookie("uuid", this.uuid), this.isFirstStart = this.uuid === e, "" !== t && this.init();
  }

  return t.version = function () {
    return version_1.version;
  }, t.prototype.close = function () {
    this.connectivitySubscription.unsubscribe(), this.detectionSuccessSubscription.unsubscribe(), this.detectionErrorSubscription.unsubscribe(), this.interactionSubscription.unsubscribe(), this.initialisationSubscription.unsubscribe(), this.progressSubscription.unsubscribe(), this.usabilitySubscription.unsubscribe(), this.tutorialSubscription.unsubscribe();
  }, t.prototype.pause = function () {
    this.getDetection().pause(), this.getUsability().pause(), this.getProgress().pause();
  }, t.prototype.resume = function () {
    this.getDetection().resume(), this.getUsability().resume(), this.getProgress().resume();
  }, t.prototype.getAPIKey = function () {
    return this.APIKey;
  }, t.prototype.getServerUrl = function () {
    return this.serverURL;
  }, t.prototype.getUUID = function () {
    return this.uuid;
  }, t.prototype.getSessionToken = function () {
    return this.getInitialisation().initialisationResponse && this.getInitialisation().initialisationResponse.sessionToken || "";
  }, t.prototype.isRunningStandalone = function () {
    return window.matchMedia("(display-mode: standalone)").matches || !0 === window.navigator.standalone;
  }, t.prototype.setCustomPayload = function (t) {
    return this.getDetection().setCustomPayload(t);
  }, t.prototype.getInitialisation = function () {
    return null === this.initialisation && (this.initialisation = new Initialisation_1.Initialisation(this)), this.initialisation;
  }, t.prototype.getInitialisationSubject = function () {
    return this.getInitialisation().subject;
  }, t.prototype.getProgress = function () {
    return null === this.progress && (this.progress = new Progress_1.Progress(this)), this.progress;
  }, t.prototype.getProgressSubject = function () {
    return this.getProgress().subject;
  }, t.prototype.getUsability = function () {
    return null === this.usability && (this.usability = new Usability_1.Usability(this.strings)), this.usability;
  }, t.prototype.getUsabilitySubject = function () {
    return this.getUsability().subject;
  }, t.prototype.getInteraction = function () {
    return null === this.interaction && (this.interaction = new Interaction_1.Interaction()), this.interaction;
  }, t.prototype.getInteractionSubject = function () {
    return this.getInteraction().subject;
  }, t.prototype.getConnectivity = function () {
    return null === this.connectivity && (this.connectivity = new Connectivity_1.Connectivity(this, 1500)), this.connectivity;
  }, t.prototype.getConnectivitySubject = function () {
    return this.getConnectivity().subject;
  }, t.prototype.getDetection = function () {
    return null === this.detection && (this.detection = new Detection_1.Detection(this, this.strings)), this.detection;
  }, t.prototype.getDetectionSuccessSubject = function () {
    return this.getDetection().successSubject;
  }, t.prototype.getPrismaKeyDetectionSubject = function () {
    return this.getDetection().prismaKeyDetection ? this.getDetection().prismaKeyDetection.keyDetectionSubject : null;
  }, t.prototype.getDetectionErrorSubject = function () {
    return this.getDetection().errorSubject;
  }, t.prototype.getTutorial = function () {
    return null === this.tutorial && (this.tutorial = new Tutorial_1.Tutorial(this)), this.tutorial;
  }, t.prototype.getTutorialSubject = function () {
    return this.getTutorial().subject;
  }, t.prototype.attachToElement = function (t) {
    var i = this;
    t.addEventListener("touchstart", function (t) {
      t.preventDefault(), i.getDetection().processTouchStart(t);
    }, !1), t.addEventListener("touchmove", function (t) {
      t.preventDefault(), i.getDetection().processTouchMove(t);
    }, !1), t.addEventListener("touchend", function (t) {
      t.preventDefault(), i.getDetection().processTouchEnd(t);
    }, !1), t.addEventListener("touchcancel", function (t) {
      t.preventDefault(), i.getDetection().processTouchCancel(t), i.getUsability().touchesCancelled();
    }, !1);
  }, t.prototype.setAppTypeNative = function () {
    this.appType = "native";
  }, t.prototype.setPrismaKeyCardBounds = function (t, i, e, n) {
    this.getDetection().prismaKeyDetection && this.getDetection().prismaKeyDetection.setPrismaKeyCardBounds(t, i, e, n);
  }, t.prototype.setCoordinatesUnitPixels = function () {
    this.coordinatesUnit = "pixels";
  }, t.prototype.getAppType = function () {
    return this.appType;
  }, t.prototype.getCoordinatesUnit = function () {
    return this.coordinatesUnit;
  }, t.prototype.setLanguage = function (t) {
    this.strings.forcedLanguage = t;
  }, t.prototype.getDataManager = function () {
    return null === this.dataManager && (this.dataManager = new DataManager_1.DataManager(this)), this.dataManager;
  }, t.prototype.getDataManagerSubject = function () {
    return this.getDataManager().subject;
  }, t.prototype.setTwoFingerHoldingMode = function (t) {
    this.getDetection().twoFingerHoldingMode = t, this.getUsability().twoFingerHoldingMode = t;
  }, t.prototype.setExpectedTouchRadius = function (t) {
    this.getProgress().expectedTouchRadius = t;
  }, t.prototype.setScreenResolutionScaleFactor = function (t) {
    this.screenResolutionScaleFactor = t;
  }, t.prototype.getScreenResolutionScaleFactor = function () {
    return this.screenResolutionScaleFactor;
  }, t.prototype.init = function () {
    var i = this;
    this.connectivitySubscription = this.getConnectivitySubject().pipe(operators_1.take(1)).subscribe(function (t) {
      i.getTutorial().loadData(), i.getInitialisation().loadData();
    }), this.connectivity.startCheck(), this.progressSubscription = this.getProgressSubject().subscribe(function (t) {
      i.getUsability().progress(t);
    }), this.detectionSuccessSubscription = this.getDetectionSuccessSubject().subscribe(function (t) {}), this.detectionErrorSubscription = this.getDetectionErrorSubject().subscribe(function (t) {}), this.interactionSubscription = this.getInteractionSubject().subscribe(function (t) {
      i.getUsability().interaction(t);
    }), this.initialisationSubscription = this.getInitialisationSubject().subscribe(function (t) {
      i.getDetection().init(t), i.getUsability().init(t), i.getProgress().init(t), i.getDataManager().postprocessInitialisation(t);
    }), this.usabilitySubscription = this.getUsabilitySubject().subscribe(function (t) {}), this.tutorialSubscription = this.getTutorialSubject().subscribe(function (t) {});
  }, t;
}();

exports.PrismaSDK = PrismaSDK;